import { useRouter } from "@tanstack/react-router";
import { ReactNode, createContext, useContext } from "react";

export enum NavigationState {
    IDLE = "idle",
    LOADING = "loading",
    SUBMITTING = "submitting",
}

interface NavigationLoadingContextType {
    isNavigating: boolean;
}

const NavigationLoadingContext = createContext<NavigationLoadingContextType | undefined>(undefined);

export const useNavigationLoading = () => {
    const context = useContext(NavigationLoadingContext);
    if (!context) {
        throw new Error("useNavigationLoading must be used within a NavigationLoadingProvider");
    }
    return context;
};

interface NavigationLoadingProviderProps {
    children: ReactNode;
}

export const NavigationLoadingProvider = ({ children }: NavigationLoadingProviderProps) => {
    const router = useRouter();
    const isNavigating = router.state.status === "pending";

    return <NavigationLoadingContext.Provider value={{ isNavigating }}>{children}</NavigationLoadingContext.Provider>;
};
